export default {
    productIdServer: '279620588',
    apikey: '79f348448212490885017e457ea42411'
};
